import React from 'react';
import './styles.scss';

import CollapsibleCard from '../../../../common/collapsible-card';
import { Box } from '@mui/material';
import { ReactComponent as HelpCircleIcon } from '../../../../../assets/icons/help-circle.svg';
import TooltipIcon from '../../../../common/tooltip-icon';
import Parser from 'html-react-parser';
import l from '../../../../../lang';
import { ReactComponent as QuestionIcon } from '../../../../../assets/icons/benefits/question.svg';
import { ReactComponent as UserIcon } from '../../../../../assets/icons/benefits/user.svg';
import { ReactComponent as BulbIcon } from '../../../../../assets/icons/benefits/bulb.svg';
import { ReactComponent as SearchIcon } from '../../../../../assets/icons/benefits/search.svg';

interface BenefitSection {
  title: string;
  description: string;
  exampleList?: string;
  icon?: React.ReactNode;
}

interface Benefit {
  title: string;
  helpText: string;
  sections: BenefitSection[];
}

const benefitsData = [
  {
    title: l('affiliations.benefits.0.title'),
    helpText: l('affiliations.benefits.0.helpText'),
    sections: [
      {
        title: l('affiliations.benefits.0.sections.0.title'),
        description: l('affiliations.benefits.0.sections.0.description'),
        exampleList: l('affiliations.benefits.0.sections.0.example'),
      },
      {
        title: l('affiliations.benefits.0.sections.1.title'),
        description: l('affiliations.benefits.0.sections.1.description'),
      },
      {
        title: l('affiliations.benefits.0.sections.2.title'),
        description: l('affiliations.benefits.0.sections.2.description'),
        exampleList: l('affiliations.benefits.0.sections.2.example'),
      },
      {
        title: l('affiliations.benefits.0.sections.3.title'),
        description: l('affiliations.benefits.0.sections.3.description'),
      },
    ],
  },
  {
    title: l('affiliations.benefits.1.title'),
    helpText: l('affiliations.benefits.1.helpText'),
    sections: [
      {
        title: l('affiliations.benefits.1.sections.0.title'),
        description: l('affiliations.benefits.1.sections.0.description'),
        exampleList: l('affiliations.benefits.1.sections.0.example'),
      },
      {
        title: l('affiliations.benefits.1.sections.1.title'),
        description: l('affiliations.benefits.1.sections.1.description'),
      },
    ],
  },
  {
    title: l('affiliations.benefits.2.title'),
    helpText: l('affiliations.benefits.2.helpText'),
    sections: [
      {
        title: l('affiliations.benefits.2.sections.0.title'),
        description: l('affiliations.benefits.2.sections.0.description'),
        icon: <QuestionIcon />,
      },
      {
        title: l('affiliations.benefits.2.sections.1.title'),
        description: l('affiliations.benefits.2.sections.1.description'),
        icon: <UserIcon />,
      },
      {
        title: l('affiliations.benefits.2.sections.2.title'),
        description: l('affiliations.benefits.2.sections.2.description'),
        icon: <BulbIcon />,
      },
      {
        title: l('affiliations.benefits.2.sections.3.title'),
        description: l('affiliations.benefits.2.sections.3.description'),
        icon: <SearchIcon />,
      },
    ],
  },
] as Benefit[];

const Benefits = () => {
  return benefitsData.map(benefit => (
    <Box className="benefits">
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <h4>{benefit.title}</h4>
        <TooltipIcon placement="bottom" text={benefit.helpText} icon={<HelpCircleIcon />} />
      </Box>
      <Box className="benefits-container">
        {benefit.sections.map((section, index) => (
          <Box key={index} sx={{ marginBottom: '20px' }}>
            <CollapsibleCard title={section.title} defaultExpanded={false} icon={section.icon}>
              <div className="collapsible_card_body">
                <div>{Parser(section.description)}</div>
                {section.exampleList && (
                  <div className="collapsible_card_body__example">
                    <h6 className="text-bold">{l('affiliations.benefits.example')}:</h6>
                    {Parser(section.exampleList)}
                  </div>
                )}
              </div>
            </CollapsibleCard>
          </Box>
        ))}
      </Box>
    </Box>
  ));
};

export default Benefits;
